<template>
  <div>
    <div class="mb_head">
      <div class="mb-logo">
        <img src="@/assets/images/0_img_logo.png" alt="Logo" class="logo" />
      </div>
      <div class="menu" @click="mb_drawer = !mb_drawer">≡</div>
    </div>
    <el-drawer
        :visible.sync="mb_drawer"
        size="330px"
        style="position: absolute;top: 55px"
        direction='rtl'>
      <div class="MobileMenu">
        <div class="nav-item" @click="toDetail('/mb_home')">HOME</div>
        <div class="nav-item" @click="toDetail('/mb_about')">ABOUT US</div>
        <div class="nav-item" @click="toDetail('/mb_technology')">TECHNOLOGY</div>
        <div class="nav-item" style="display: flex;justify-content: space-between">
          <span>SERVICES</span>
          <i @click="showServicesList" style="margin-right: 15px" class="el-icon-arrow-down"></i>
        </div>
        <div class="serviceList" v-if="serviceListVisble">
          <div class="li" @click="toDetail('/mb_platform')">One-stop Planning</div>
          <div class="li" @click="toDetail('/mb_registration')">Registration Services</div>
          <div class="li" @click="toDetail('/mb_populariz')">Product Promotion</div>
          <div class="li" @click="toDetail('/mb_expansion')">Market Exploration</div>
          <div class="li" @click="toDetail('/mb_material')">Raw Material Customization</div>
          <div class="li" @click="toDetail('/mb_flow')">Product Customization</div>
          <div class="li" @click="toDetail('/mb_business')">Import and Export</div>
        </div>
        <div class="nav-item" @click="toDetail('/mb_contacts')">CONTACTS</div>
      </div>
    </el-drawer>
  </div>
</template>

<script>
export default {
  name: "mobileHeadView",
  data() {
    return {
      mb_drawer: false,
      serviceListVisble: false,
    }
  },
  methods: {
    toDetail(url) {
      this.$router.push(url).catch(err => {
        console.log('输出报错',err)
      })
      this.mb_drawer = false

    },
    showServicesList() {
      this.serviceListVisble = !this.serviceListVisble
    },
  }
}
</script>

<style scoped lang="less">
.el-drawer__wrapper {
  /deep/ .el-drawer__header {
    display: none;
  }
}
.mb-logo {
  background-color: #fff;
  .logo {
    width: 120px;
    margin-top: 10px;
  }
}
.mb_head {
  background-color: #fff;
  display: flex;
  position: fixed;
  //height: 100%;
  align-items: center;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 99;
  justify-content: space-between;
  padding: 0 20px;
  border-bottom: 1px solid #ccc;
  .menu {
    font-size: 30px;
  }
}
.MobileMenu {
  z-index: 999;
  background-color: #fff;
  //position: fixed;
  //top: 55px;
  //right: 0;
  width: 330px;
  //box-shadow: 0px 0px 3px 0px rgba(0,0,0,0.4);
  //height: 500px;
  .nav-item {
    font-size: 14px;
    padding: 15px 0 15px 20px;
    border-bottom: 1px solid #ccc;
  }
  .nav-item:last-child {
    //border-bottom: none;
  }
  .serviceList {
    display: block;
    height: 100%;
    .li {
      font-size: 14px;
      height: 50px !important;
      line-height: 50px;
      margin: 0 0  0 100px;
      border-bottom: 1px solid #ccc;
    }
  }
}

</style>
